// src/components/auth/Login.jsx - UPDATED with Real Authentication
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Shield, Mail, ArrowRight, UserPlus } from 'lucide-react';

// Import our component library
import {
  AuthLayout,
  AuthCard,
  AuthHeader,
  Button,
  Input,
  FormField,
  PasswordInput,
  Divider
} from '../ui';
import { Alert, AlertDescription } from '../ui/alert';

// Import the real auth context
import { useAuth } from '../../contexts/AuthContext.jsx';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  
  const navigate = useNavigate();
  
  // Use the real auth context instead of local state
  const { login, loading, error } = useAuth();
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Use the real authentication system
    const success = await login(email, password);
    
    if (success) {
      console.log('✅ Login successful, redirecting to dashboard');
      navigate('/dashboard');
    }
    // Error handling is automatically done by AuthContext
  };
  
  return (
    <AuthLayout>
      <AuthCard>
        {/* Header */}
        <AuthHeader
          icon={Shield}
          title="Welcome Back"
          subtitle="Sign in to your business dashboard"
        />

        {/* Error Display */}
        {error && (
          <Alert variant="destructive" className="mb-6">
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}
        
        {/* Login Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Email Field */}
          <FormField label="Email Address" required>
            <Input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              leftIcon={Mail}
              required
              disabled={loading}
            />
          </FormField>

          {/* Password Field */}
          <FormField label="Password" required>
            <PasswordInput
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              disabled={loading}
            />
          </FormField>

          {/* Login Button */}
          <Button
            type="submit"
            variant="primary"
            size="md"
            isLoading={loading}
            disabled={!email || !password || loading}
            icon={ArrowRight}
            iconPosition="right"
            className="w-full"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>

        {/* Divider */}
        <Divider text="New partner?" />

        {/* New Partner Button */}
        <Button
          as={Link}
          to="/partner-signup"
          variant="secondary"
          size="md"
          icon={UserPlus}
          className="w-full"
          disabled={loading}
        >
          Join as New Partner
        </Button>
      </AuthCard>
    </AuthLayout>
  );
};

export default Login;